import React from "react";
import ReactDOM from "react-dom/client";

import { EventType } from "@azure/msal-browser";
import { HashRouter } from "react-router-dom";
import {Provider} from "react-redux";
import { msalInstance } from "./msalInstance.js";
import App from "./App";

import "./styles/index.css";
import { store } from "./store/index.js";

import { LicenseInfo } from '@mui/x-license';
//LicenseInfo.setLicenseKey('3723388ff45e0876e57eaefc98063c27Tz0xMDE4NDEsRT0xNzYzMjM0MDM4MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');
LicenseInfo.setLicenseKey('3dd2619d2e731efd5271c9909c7c146aTz0xMjgzNDEsRT0xNzk1MzkxOTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEsQVQ9c2luZ2xlLEtWPTI=');
// The MSAL instance is created in ./msalInstance.js so the RTK base query can share it.

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.addEventCallback((event) => {
    if (
        (event.eventType === EventType.LOGIN_SUCCESS ||
            event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
            event.eventType === EventType.SSO_SILENT_SUCCESS) &&
        event.payload.account
    ) {
        msalInstance.setActiveAccount(event.payload.account);
    }
});
const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApp = () => {
    root.render(
        <React.StrictMode>
            <Provider store={store}>
                <HashRouter >
                    <App instance={msalInstance} />
                </HashRouter>
            </Provider>
        </React.StrictMode>
    );
};

// Process any pending redirect response before mounting React.
// This prevents useMsalAuthentication from firing a second redirect
// while the first redirect's response is still being handled, which
// causes the interaction_in_progress error on token expiry.
msalInstance.handleRedirectPromise()
    .then(renderApp)
    .catch((error) => {
        console.error(error);
        renderApp();
    });
